import React from 'react';
import { Hero } from '../components/Hero';
import { SalesLetter } from '../components/SalesLetter';
import { PreviewCarousel } from '../components/PreviewCarousel';
import { BonusSection } from '../components/BonusSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { PricingSection } from '../components/PricingSection';
import { UpsellSection } from '../components/UpsellSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FAQSection } from '../components/FAQSection';
import { PurchaseNotification } from '../components/PurchaseNotification';
export function SalesPage() {
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-351">
      <header className="bg-white border-b border-slate-200 py-4 sticky top-0 z-40 shadow-sm" data-id="element-352">
        <div className="max-w-6xl mx-auto px-4 flex justify-between items-center" data-id="element-353">
          <div className="font-black text-2xl tracking-tight text-slate-900" data-id="element-354">
            SIC<span className="text-blue-600" data-id="element-355">360</span>
          </div>
          <button onClick={() => document.getElementById('purchase')?.scrollIntoView({
          behavior: 'smooth'
        })} className="bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold px-5 py-2.5 rounded-lg transition-colors" data-id="element-356">
            Comprar Ahora
          </button>
        </div>
      </header>

      <main data-id="element-357">
        <Hero data-id="element-358" />
        <SalesLetter data-id="element-359" />
        <PreviewCarousel data-id="element-360" />
        <BonusSection data-id="element-361" />
        <PricingSection data-id="element-362" />
        <UpsellSection data-id="element-363" />
        <GuaranteeSection data-id="element-364" />
        <TestimonialsSection data-id="element-365" />
        <FAQSection data-id="element-366" />
      </main>

      <footer className="bg-slate-900 text-slate-400 py-12 text-center text-sm" data-id="element-367">
        <div className="max-w-6xl mx-auto px-4" data-id="element-368">
          <p className="mb-4 font-bold text-white text-lg" data-id="element-369">SIC 360</p>
          <p data-id="element-370">© {new Date().getFullYear()} Todos los derechos reservados.</p>
          <p className="mt-2" data-id="element-371">Hecho con ❤️ para la docencia argentina.</p>
        </div>
      </footer>

      <PurchaseNotification data-id="element-372" />
    </div>;
}